import { render, staticRenderFns } from "./UploadFichier.vue?vue&type=template&id=1e8628b9&scoped=true"
import script from "./UploadFichier.vue?vue&type=script&lang=js"
export * from "./UploadFichier.vue?vue&type=script&lang=js"
import style0 from "./UploadFichier.vue?vue&type=style&index=0&id=1e8628b9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e8628b9",
  null
  
)

export default component.exports